export const _HIDE_DELAY = 1000 * 2 // 2 seconds
